import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useAtom } from "jotai";
import { FC } from "react";
import { modalDeleteCompany } from "../../../atoms/atom";
import { ExternalCompanyService } from "../../../services/ExternalCompanyService";
import { useAlert } from "../../contextProviders/AlertProvider";

const ModalDeleteCompany: FC = () => {
	const [open, setOpen] = useAtom(modalDeleteCompany);
	const { showAlert, showError } = useAlert();

	return (
		<Dialog
			open={!!open}
			onClose={() => setOpen(null)}
			id='modal-delete'
		>
			<DialogTitle>Apagar empresa externa</DialogTitle>
			<DialogContent>
				Você tem certeza que deseja excluir esta empresa externa? Esta ação não poderá ser desfeita!
			</DialogContent>
			<DialogActions>
				<Button onClick={() => setOpen(null)}>
					Fechar
				</Button>
				<Button color="error" onClick={() => deleteAccount()}>
					Excluir
				</Button>
			</DialogActions>
		</Dialog>
	);

	async function deleteAccount() {
		const service = new ExternalCompanyService();
		let response = await service.delete(open || 0);
		setOpen(null);
		if (response?.status === 200) {
			showAlert("Empresa removida", "success");
		} else {
			showError();
		}
	}
}

export default ModalDeleteCompany;